//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';
import { TeacherPrivilegesAndSettingsInputItem } from './TeacherPrivilegesAndSettingsInputItem';

export class TeacherInputItem extends ItemBase {
    Address: string | null = null;
    EmailAddress: string | null = null;
    FirstName: string | null = null;
    LastName: string | null = null;
    TagIDs?: string[];
    TelephoneNumber: string | null = null;
    Title: string | null = null;
    ZoomMeetingURL: string | null = null;
    Note: string | null = null;
    BiographyBody: string | null = null;
    TimeZoneID: string | null = null;
    SpokenLanguages: string[] = [];
    PrivilegesAndSettings: TeacherPrivilegesAndSettingsInputItem | null = null;

    constructor(initializer?: Partial<TeacherInputItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "TeacherInputItem";
}
